(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/api-proxy/assets/javascripts/handlers/player-handlers.js') >= 0) return;  svs.modules.push('/components/lb-utils/api-proxy/assets/javascripts/handlers/player-handlers.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const trinidad = svs.isServer ? require('@svenskaspelab/trinidad-core').core : svs.core;
const apiProxyComponent = svs.isServer ? trinidad.components.require('lb-utils', 'api-proxy') : svs.components.lbUtils.apiProxy;
const _ref = svs.isServer ? apiProxyComponent.proxyHandler : apiProxyComponent,
  http = _ref.http;
const featureToggle = apiProxyComponent.featureToggle;
const FEATURE_TOGGLE = apiProxyComponent.constants.FEATURE_TOGGLE;
const config = {
  shouldUseCloud: async options => {
    const isEnabled = await featureToggle(FEATURE_TOGGLE.MARKETPLACE_PAM_CORE_CLOUD_API, options);
    return isEnabled;
  }
};

const playerInfoResolver = async _ref2 => {
  let data = _ref2.data;
  return {
    accountBalance: data.balance,
    firstName: data.firstName,
    lastName: data.lastName,
    ssn: data.ssn
  };
};

const customizedSettingsResolver = async _ref3 => {
  let data = _ref3.data;
  return {
    customizedSettings: {
      properties: data
    }
  };
};

const gameLimitsResolver = async _ref4 => {
  let data = _ref4.data;
  return data;
};
const playerHandlers = [http.get('/player/1/info', playerInfoResolver, {
  config: _objectSpread(_objectSpread({}, config), {}, {
    cloudEndpointTemplate: '/api/v1/properties?fields=balance,firstName,lastName,ssn'
  })
}), http.get('/player/2/customizedsettings', customizedSettingsResolver, {
  config: _objectSpread(_objectSpread({}, config), {}, {
    cloudEndpointTemplate: '/api/v1/properties?fields=customerId'
  })
}), http.get('/player/1/gamelimits', gameLimitsResolver, {
  config: _objectSpread(_objectSpread({}, config), {}, {
    cloudEndpointTemplate: '/api/v1/limits'
  })
})];
if (svs.isServer) {
  module.exports = playerHandlers;
} else {
  setGlobal('svs.components.lbUtils.apiProxy.handlers.playerHandlers', playerHandlers);
}

 })(window);